import * as AppPics from 'assets/images';
import useCourse from 'hooks/API/GET/useCourse';
import useManageCourse from 'hooks/API/useManageCourse';
import useToaster from 'hooks/useToaster';
import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import CourseInfo from './CourseInfo';

function ManageCourse({ editMode }) {
  const { courseID } = useParams();
  const [activeTab, setActiveTab] = useState('course_info');
  const { isLoading, mutate, isError } = useManageCourse();
  const { data: courseDetails } = useCourse({ courseID, enabled: !!courseID });

  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  function handleSave(data = {}) {
    if (isLoading) return;

    if (data?.id) {
      mutate({ type: 'UPDATE', ...data });
      return;
    }

    mutate({ ...data });
  }

  return (
    <div className="mainWraper addcoursesection">
      <div className="tab">
        <ul className="tab__menu">
          <Link to="/courses">
            <Back />
          </Link>
          <li onClick={() => setActiveTab('course_info')} className="active">
            Course Info
          </li>
          <li
            onClick={() => {
              return;
              // setActiveTab('');
            }}
            className="lock"
          >
            Course Timeline
          </li>
          <li
            onClick={() => {
              return;
              // setActiveTab('');
            }}
            className="lock"
          >
            Course Audience
          </li>
          <li
            onClick={() => {
              return;
              // setActiveTab('');
            }}
            className="lock"
          >
            Course Membership
          </li>
          <li
            onClick={() => {
              return;
              // setActiveTab('');
            }}
            className="lock"
          >
            Course Analytics
          </li>
        </ul>
        <div className="tab__content">
          {activeTab === 'course_info' && (
            <CourseInfo
              editMode={editMode}
              handleSave={handleSave}
              details={courseDetails?.data || {}}
            />
          )}
        </div>
      </div>
    </div>
  );
}

function Back() {
  return (
    <li className="back">
      <button className="btn-back">
        <img src={AppPics.BackSvg} alt="" />
      </button>
    </li>
  );
}

export default ManageCourse;
